import React from 'react';
import AccountSelect, { BasicAccount } from './AccountSelect';
import Dialog, { DialogProps } from '../dialog/Dialog';

export interface AccountSelectModalProps extends DialogProps {
    onSelectAccount: (account: BasicAccount) => void;
}

export const AccountSelectModal: React.FC<AccountSelectModalProps> = ({ onSelectAccount, ...props }) => {
    return (
        <Dialog {...props}>
            <div className={'flex flex-col flex-auto px-30 pb-30 pt-20 overflow-y-auto'}>
                <AccountSelect
                    onSelect={(account) => {
                        onSelectAccount(account);
                    }}
                    hideHeader={true}
                ></AccountSelect>
            </div>
        </Dialog>
    );
};
